<div class="forgot-page">
  <div class="forgot-container">
    <div class="forgot-card">
      <div class="forgot-header">
        <h3>Recuperare parolă</h3>
        <p>
          Introdu adresa de email folosită la înregistrare.
          Dacă există în sistem, vei primi un mesaj cu un link de resetare.
        </p>
      </div>

      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-group mb-3">
          <label class="form-label">Email</label>
          <input
            type="email"
            class="form-control"
            placeholder="exemplu@domeniu.ro"
            formControlName="email"
            [class.is-invalid]="submitted && form.get('email')?.invalid"
          />

          <div
            class="invalid-feedback"
            *ngIf="submitted && form.get('email')?.hasError('required')"
          >
            Emailul este obligatoriu.
          </div>

          <div
            class="invalid-feedback"
            *ngIf="submitted && form.get('email')?.hasError('email')"
          >
            Introdu un email valid.
          </div>
        </div>

            <button
            type="submit"
          class="btn btn-primary w-100 mb-3"
          [disabled]="form.pending || (form.invalid && submitted)"
        >
          Trimite link de resetare
        </button>

        <div class="text-center mb-2">
          <a routerLink="/login" class="back-link">
            Înapoi la autentificare
          </a>
        </div>

        <div
          class="alert alert-success mt-3"
          *ngIf="successMessage"
        >
          {{ successMessage }}
        </div>

        <div
          class="alert alert-danger mt-3"
          *ngIf="errorMessage"
        >
          {{ errorMessage }}
        </div>
      </form>

      <div class="forgot-footer">
        <small>
          Pentru suport suplimentar, ne puteți contacta la
          <a href="mailto:portal@spitalcfpascani.ro">
            portal@spitalcfpascani.ro
          </a>.
        </small>
      </div>
    </div>
  </div>
</div>
